import React from "react";
import { useEffect } from "react";
import "./App.css";
import { FaInstagram, FaTwitter } from "react-icons/fa";


export function App() {
  useEffect(() => {
    document.documentElement.style.backgroundColor = '#000000';
  }, []);

  return (
    <div className={`flex flex-col justify-center items-center text-white bg-agiBlack font-DMSans`}>
      {/* NAV */}
      <div className={`w-screen flex justify-center bg-agiBlack bg-opacity-60 backdrop-blur-lg z-50 fixed top-0`}>
      <div className="flex justify-between max-w-[1200px] w-full md:py-8 md:px-10 px-4 py-6 z-50 items-center">
      <a href="https://agihouse.org" target="_blank" rel="noopener noreferrer">
       <div className="flex flex-row gap-5 items-center">
          <img src="imgs/AGIICON4Dark.svg" alt="AGI Accelerator" className="h-12 sm:block hidden" />
        
        <div className="w-full gap-0 flex-col">
          <h1 className="md:text-2xl text-base font-DMMono font-medium leading-none md:mb-[-3px] md:mt-[1px]">AGI ACCELERATOR</h1>
          <h1 className={`md:text-lg text-xs font-DMMono font-medium leading-none md:mt-[-3px] mt-1 text-agiLightGray`}>BY AGI HOUSE</h1>
        </div>
        </div>
        </a>

        <div className="flex gap-4">
        <div className="flex w-full justify-end gap-3 font-bold item-center">
          <a className="h-11 md:w-32 w-24 rounded-full justify-center items-center bg-white text-agiBlack flex"
            href="https://forms.gle/ueGdhZh4KP4ASDmM7"
            target="_blank"
            rel="noopener noreferrer"
          >APPLY
          </a>
        </div>
        </div>
      </div>
      </div>

      <div
        className="w-full flex justify-center mt-40"
      >
        <div className="max-w-[1200px] w-full flex flex-col md:px-10 px-4">
<div className="flex w-full md:flex-row flex-col-reverse">
<div className="relative flex flex-col md:gap-4 gap-2 md:p-12 p-8">
  <h3 className="md:text-5xl text-3xl font-medium">AGI Accelerator</h3>
  <p className="md:text-xl text-lg text-agiLightGray leading-loose">
  AGI Accelerator is the first AI-Native startup accelerator for ambitious founders that are re-imagining traditional enterprise workflow and user experience with AI-native products built on top of foundation models.</p>
  <div className="absolute h-6 w-6 top-0 left-0 border-agiGray border-l border-t"></div>
      <div className="absolute h-6 w-6 top-0 right-0 border-agiGray border-r border-t"></div>
      <div className="absolute h-6 w-6 bottom-0 left-0 border-agiGray border-l border-b"></div>
      <div className="absolute h-6 w-6 bottom-0 right-0 border-agiGray border-r border-b"></div>
</div>
<div className="relative flex items-center justify-center gap-4 md:p-12 p-8 md:ml-[-1px] md:mb-[0px] mb-[-1px]">
  <a href="https://agihouse.org" target="_blank" rel="noopener noreferrer">
  <img src="imgs/AGIFellowsDark.svg" alt="AGI Fellows" className="md:w-[400px] w-[150px]" />
  </a>
  <div className="absolute h-6 w-6 top-0 left-0 border-agiGray border-l border-t"></div>
  <div className="absolute h-6 w-6 top-0 right-0 border-agiGray border-r border-t"></div>
  <div className="absolute h-6 w-6 bottom-0 left-0 border-agiGray border-l border-b"></div>
  <div className="absolute h-6 w-6 bottom-0 right-0 border-agiGray border-r border-b"></div>
</div>
</div>

<div className="relative flex flex-col gap-4 md:p-12 p-8 mt-[-1px]">
  <h3 className="md:text-3xl text-xl font-medium">What You Get:</h3>
  
  <div className="space-y-8">
    <div>
      <h4 className="text-xl font-medium mb-2 text-white">World Class Mentorship and Company Building Support</h4>
      <ul className="md:text-lg text-base text-agiLightGray leading-loose list-disc list-inside space-y-2">
        <li>Tactical advice from top founders, operators, and domain experts</li>
        <li>Weekly workshops, pitch nights, and curated meetups for rapid learning and connection</li>
      </ul>
    </div>

    <div>
      <h4 className="text-xl font-medium mb-2 text-white">Workspace and Infrastructure</h4>
      <ul className="md:text-lg text-base text-agiLightGray leading-loose list-disc list-inside space-y-2">
        <li>Full access to AGI House's Bay Area co-working space (<a href="https://www.agihouse.org" target="_blank" rel="noopener noreferrer" className="text-agiLightGray underline underline-offset-2 opacity-75 hover:opacity-100">agihouse.org</a>)</li>
        <li>On-demand compute, lab access, and partnerships with top hardware providers</li>
      </ul>
    </div>

    <div>
      <h4 className="text-xl font-medium mb-2 text-white">Funding and Investor Access</h4>
      <ul className="md:text-lg text-base text-agiLightGray leading-loose list-disc list-inside space-y-2">
        <li>$500,000 in equity investment and exposure to top tier investors through our in person demo days and community investor events</li>
        <li>$1-2M in partner credits</li>
      </ul>
    </div>

    <div>
      <h4 className="text-xl font-medium mb-2 text-white">Global Community and Talent Network</h4>
      <ul className="md:text-lg text-base text-agiLightGray leading-loose list-disc list-inside space-y-2">
        <li>Fireside chats, curated dinners, exclusive events, and AGI-only hackathons with top AI talent from a global network of 10,000+ experts.</li>
        <li>Access to an internal job board and dedicated recruiting support.</li>
      </ul>
    </div>

    <div>
      <h4 className="text-xl font-medium mb-2 text-white">AGI House Labs: Enterprise Network & Industry Adoption</h4>
      <ul className="md:text-lg text-base text-agiLightGray leading-loose list-disc list-inside space-y-2">
        <li>Direct access to enterprise partners actively seeking AI solutions through sponsorship and co-hosted events with global tech and Fortune 500 leaders</li>
        <li>Pilot opportunities and validation pathways through our corporate innovation network</li>
      </ul>
    </div>
  </div>
</div>

<div className="relative flex flex-col gap-4 md:p-12 p-8 mt-[-1px]">
  <h3 className="md:text-3xl text-xl font-medium">Who We Are:</h3>
  <div className="md:text-lg text-base text-agiLightGray leading-loose space-y-4">
    <p>At AGI House, our mission is to accelerate humanity's transition to AGI. Through a diverse range of events, operations, and pre/seed stage investments, we aspire to build the operating system that will redesign the digital infrastructure for the mass adoption of Gen AI technology across different industry verticals and consumer experiences, in collaboration with talented founders and researchers in the AGI House community.</p>
    <p>Our events have featured distinguished guests like Sergey Brin, Andrej Karpathy, Grimes, Eric Schmidt, Jeff Dean, Sebastian Thrun, founders from OpenAI, Anthropic, Huggingface, and other top AI startups, alongside renowned investors, researchers, and engineers from various institutions.</p>
  </div>
</div>


        </div>
      </div>

<div className="relative  flex-col gap-4 md:p-12 p-8 w-full flex items-center mt-16 mb-24">
  <h3 className="md:text-5xl text-3xl font-medium max-w-[80vw] text-center">What will your next token be?</h3>
  <div className="mt-4 flex w-full justify-center gap-3 font-bold item-center">
  <a className="h-16 w-48 text-lg rounded-full justify-center items-center bg-white text-agiBlack flex"
            href="https://forms.gle/ueGdhZh4KP4ASDmM7"
            target="_blank"
            rel="noopener noreferrer"
          >APPLY
          </a>
        </div>
          </div>

      <div className="w-full flex justify-center mb-10">
        <div className="text-agiLightGray w-full max-w-[1200px] px-10 flex justify-between items-end">
          <div className="">© 2025 AGI House</div>
          <div className="flex gap-8 6">
            <a href="https://twitter.com/agihouse_org" target="_blank" rel="noopener noreferrer">
              <FaTwitter className=" text-3xl" />
            </a>
            <a href="https://www.instagram.com/agihouse_org/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className=" text-3xl" />
            </a>
          </div>
        </div>
      </div>    
    </div>
  );
}

export default App;
